<template>
  <div class="wl-results" v-if="doc">
    <results-bar :doc="doc" @loadSummary="loadSummary" @loadUser="loadUser"></results-bar>
    <results-summary v-if="summary" :id="doc.id" :summaryMode="summaryMode"></results-summary>
    <results-user v-if="!summary" :uid="currentUser"></results-user>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { store } from '@/store.js'
import {
  ResultsSummary,
  ResultsUser,
  ResultsBar
} from "@/components/results/archetypes";
const fb = require("@/firebaseConfig.js");
export default {
  name: "ArchetypesFunctionality",
  props: {
    doc: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      summary: true,
      summaryMode: "popular",
      currentUser: null,
      userList: null
    };
  },
  components: {
    ResultsSummary,
    ResultsUser,
    ResultsBar
  },
  mounted() {
    this.getExercise();
  },
  computed: {
    ...mapState(["exArchetypes"])
  },
  methods: {
    loadSummary(mode) {
      this.currentUser = null;
      this.summaryMode = mode;
      this.summary = true;
    },
    loadUser(uid) {
      this.currentUser = uid;
      this.summary = false;
    },
    getExercise() {
      console.log('getting exercise')
      let ref = fb.archetypesExCollection.where("pid", "==", this.doc.id);
      ref
        .get()
        .then((result) => {
          let archetypes = [];
          let types = [];
          let users = [];
          let docs = [];
          result.forEach((doc) => {
            let post = doc.data();
            users.push(post.uid);
            // items.push(post);
            Object.values(post.doc.archetype).forEach((item) => {
              archetypes.push(item);
            });
            types.push(post.doc.type);
            docs.push(post.doc)
          });
          if (archetypes) {
            // this.exList = items;
             store.commit('setExArchetypes', archetypes)
             store.commit('setExTypes', types)
             store.commit('setExArchetypesSummary', docs)
          }
          if (users) {
            this.userList = users;
          }
        })
        .catch(function() {});
    },
  },
};
</script>
